import { Spinner, Text, useToast, VStack } from '@chakra-ui/react';
import usePathNavigate from 'lib/hook/usePathNavigate';
import { useEffect } from 'react';

function AuthNaver() {
  const { pathNavigate } = usePathNavigate();
  const toast = useToast();

  useEffect(() => {
    const parsedHash = new URLSearchParams(window.location.hash.substring(1));
    const nToken = parsedHash.get('access_token');
    if (nToken === null) {
      console.log('n-token이 없습니다.');
      toast({
        title: '로그인 실패',
        description: '다시 로그인 해주세요.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
      pathNavigate(`/?c=${localStorage.getItem('channel')}`);
    } else {
      localStorage.setItem('login_type', 'naver');
      localStorage.setItem('login_token', nToken);
      // console.log('nToken', nToken);
      pathNavigate(
        `/?c=${localStorage.getItem('channel')}&t=${'naver' + nToken}`
      );
    }
  }, []);
  return (
    <VStack pt="100px" gap={'20px'}>
      <Spinner color="teal.500" size="xl" />
      <Text fontSize={'1rem'} fontWeight="medium">
        로그인 중입니다.
      </Text>
    </VStack>
  );
}

export default AuthNaver;
